export const tradingPartnerKeys = {
  all: ["trading-partners"],

  lists: () => [...tradingPartnerKeys.all, "list"],

  list: (params) => [
    ...tradingPartnerKeys.lists(),
    params || {},
  ],

  details: () => [...tradingPartnerKeys.all, "detail"],

  detail: (id) => [
    ...tradingPartnerKeys.details(),
    id,
  ],

  permissions: () => [...tradingPartnerKeys.all, "permissions"],

  clients: () => [...tradingPartnerKeys.all, "clients"],

  clientList: (params) => [
    ...tradingPartnerKeys.clients(),
    params || {},
  ],
};
